import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MousePointerClick } from 'lucide-react';
import { useT } from '../i18n';
import { KitxensEffectCard } from './KitxensEffect';

const API = process.env.REACT_APP_BACKEND_URL;

export const PublicEffectDemo = () => {
  const { lang } = useT();
  const isEs = lang === 'es';
  const [period, setPeriod] = useState('year');
  const [d, setD] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/rest/public/effect?period=${period}`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setD)
      .catch(() => {});
  }, [period]);

  if (!d?.has_data) return null;
  return (
    <section className="py-16 sm:py-24 bg-[#FAFAF8] border-y border-gray-100" data-testid="public-effect-demo">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] font-bold text-[#F77F11]">
          <MousePointerClick className="w-4 h-4" />
          {isEs ? 'Pruébalo tú mismo' : 'Try it yourself'}
        </p>
        <h2 className="mt-2 text-base md:text-lg font-bold text-neutral-900">
          {isEs ? 'Así se ve el efecto Kitxens dentro de tu restaurante' : 'This is what the Kitxens effect looks like inside your restaurant'}
        </h2>
        <p className="mt-2 text-sm text-neutral-500 max-w-2xl">
          {isEs
            ? 'Demo interactiva con datos de muestra de nuestra instancia demo (Casa Mia). Cambia el periodo, elige un presupuesto y mira cómo se recalcula todo — crecimientos graduales y realistas, siempre marcados como estimados.'
            : 'Interactive demo with sample data from our demo instance (Casa Mia). Switch the period, pick a budget and watch everything recalculate — gradual, realistic growth, always marked as estimated.'}
        </p>
        <div className="mt-6">
          <KitxensEffectCard d={d} period={period} setPeriod={setPeriod} isEs={isEs} testid="home-kitxens-effect"
            subtitle={isEs ? 'Demo interactiva · datos de muestra estimados — no es un cliente real' : 'Interactive demo · estimated sample data — not a real client'} />
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <a href="#audit" data-testid="home-effect-cta-audit"
            className="inline-flex items-center gap-2 rounded-full bg-[#F77F11] hover:opacity-90 text-white font-bold text-[13.5px] px-6 py-3 transition-opacity">
            {isEs ? 'Quiero esto en mi restaurante' : 'I want this in my restaurant'}
            <ArrowRight className="w-4 h-4" />
          </a>
          <Link to="/demo" data-testid="home-effect-cta-demo"
            className="inline-flex items-center gap-2 rounded-full border border-neutral-300 hover:border-neutral-900 text-neutral-700 hover:text-neutral-900 font-bold text-[13.5px] px-6 py-3 transition-colors">
            {isEs ? 'Explorar la demo completa' : 'Explore the full demo'}
          </Link>
        </div>
      </div>
    </section>
  );
};
